import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/(portal)/listing/page.tsx");
